import { useEffect, useRef, useState } from "react";
import { Filter, SelectInput, TextInput, useDataProvider, useListContext } from "react-admin";

const trafficStatusTypes = [
    { id: 0, name: '部署初始化' },
    { id: 1, name: '部署完成' },
    { id: 2, name: '部署失败' },
    { id: 3, name: '部署超时' },
    // { id: 4, name: '未运行' },
    // { id: 5, name: '运行中' },
    { id: 6, name: '运行失败' }
];
const permanentFilter = { trafficStatusList: [0, 1, 2, 3, 6] };

// 创建自定义过滤器组件
const deployFilter = (props: any) => {
    const dataProvider = useDataProvider();
    const [loading, setLoading] = useState(true);
    const { setFilters, filterValues } = useListContext();
    const [deviceTypes, setDeviceTypes] = useState([]);
    const [customerTypeChoices, setSaleCustomers] = useState([]);

    const hasFetched = useRef(false); // 添加 useRef 标记

    useEffect(() => {
        // 如果当前没有 trafficStatusList 筛选值，则设置默认值
        if (!filterValues.trafficStatusList && filterValues.trafficStatusList != 0) {
            setFilters({ ...filterValues, ...permanentFilter }, null, false);
        }
    }, [filterValues, setFilters]);

    useEffect(() => {
        if (hasFetched.current) {
            return;
        }
        const token = localStorage.getItem("authToken");
        if (!token) {
            return; // 如果没有 token，则不请求
        }
        hasFetched.current = true; // 标记已请求

        const fetchCustomers = async () => {
            try {
                setLoading(true);
                const salesData = await dataProvider.getSalesCustomers()
                setSaleCustomers(salesData.map((item: any) => ({ id: item.id, name: item.name })));
            } catch (error) {
                console.error("获取客户数据失败:", error);
            } finally {
                setLoading(false);
            }
        };

        const fetchDeviceTypes = async () => {
            try {
                let types = await dataProvider.getDeviceList();
                types = types.map((item: any) => ({
                    id: item.name,
                    name: item.name
                }));

                setDeviceTypes(types);
            } catch (error) {
                console.error("获取设备类型失败:", error);
            }
        };

        fetchDeviceTypes();
        fetchCustomers();
    }, []);


    return (
        <Filter>
            <SelectInput
                source="saleCustomerIds"
                label="设备商家"
                choices={customerTypeChoices}
                disabled={loading}
                alwaysOn
            />
            <TextInput
                source="sns"
                label="设备SN"
                format={value => {
                    if (!value) return '';
                    // 将中文逗号、空格、分号等统一转换为英文逗号
                    return value
                        .replace(/[，；\s]+/g, ',') // 中文逗号、分号、空格转英文逗号
                }}
                alwaysOn
            />
            <SelectInput
                source="trafficStatusList"
                label="运行状态"
                choices={trafficStatusTypes}
                disabled={loading}
                alwaysOn
            />
            <SelectInput
                label="设备类型"
                source="deviceType"
                choices={deviceTypes}
                alwaysOn
            />
        </Filter>
    );
};

export default deployFilter;